import { createContext } from 'react';
import { node, object, oneOfType, arrayOf } from 'prop-types';

export const StateContext = createContext();

export const StateProvider = ({ initialState, children }) => (
  <StateContext.Provider value={initialState}>{children}</StateContext.Provider>
);

StateProvider.propTypes = {
  initialState: object.isRequired,
  children: oneOfType([arrayOf(node), node]),
};
